import React from 'react';
import { Url, URLS } from '@wix/da-url';

export interface Props {
  formRef: React.RefObject<HTMLFormElement | null>;
  label: React.ReactNode;
  token?: string;
}

export class LogoutItem extends React.Component<Props> {
  render() {
    const { formRef, token, label } = this.props;
    return (
      <>
        <form id="logout-form" ref={formRef} action={Url.buildFromPath(URLS.LOGOUT)} method="POST">
          <input type="hidden" name="validate_token" value={token} autoComplete="off" />
        </form>
        {label}
      </>
    );
  }
}

export default LogoutItem;
